export const API_BASE_URL = `${window.location.origin}${process.env.REACT_APP_API_BASE_URL}`
export const API_BASE_INCIDENT_URL = `${window.location.origin}${process.env.REACT_APP_API_BASE_INCIDENT_URL}`
export const API_BASE_IMAGE_URL = process.env.REACT_APP_API_BASE_IMAGE_URL